const PARAM = 'login_token'

const url = new URL(window.location.href)

export const urlLoginToken = url.searchParams.get(PARAM)

if (urlLoginToken) {
  url.searchParams.delete(PARAM)
  window.history.replaceState(window.history.state, '', url.toString())
}
